export default {
  props: ['id'],
  data() {
    return {
      conditionID: this.$props.id,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    condition() {
      return this.$store.state.news.condition;
    },
  },
  methods: {
    setConditionReaded() {
      const payload = {
        profile_id: this.user.profile_id,
        condition_id: +this.conditionID,
      };
      this.$store.dispatch('news/SetConditionReaded', payload);
    },
  },
  created() {
    this.user.profile_id && this.conditionID && this.setConditionReaded();
  },
};
